import Api from "@src/api";
export const InstallLocationApi= {
 
  getTreeLocationByFacilityCode(params) {
    return Api().get("InstallLocation",{params});
  },
  
};
